import { DatePicker } from "@mui/x-date-pickers";

export default function DateField(props) {
	return (
		<DatePicker sx={{ minWidth: 120, width: 120 }} slotProps={{ field: { variant: "standard" } }} views={['month', 'year', 'day']}  {...props} />
	);
}
